<template>
  <div class="Cpsl-Main" :class="HOVER_CLASS">
    <AvatarImage :src="props.icon" :size="20" />
    <span class="Cpsl-Main__txt" v-if="props.text">{{ props.text }}</span>
    <span class="Cpsl-Main__subtxt" v-if="props.subtext">{{ props.subtext }}</span>
  </div>
</template>

<script setup>
  import { Props } from './scripts/props';
  //----------------------------
  import AvatarImage from '@ui/Images/AvatarImage/AvatarImage.vue';
  //----------------------------
  const props = defineProps(Props());
  //----------------------------
  const HOVER_CLASS = (props.isHover) ? 'Cpsl-Main--hover' : '';
</script>

<style lang="scss">
  @import "./styles/styles.scss";
</style>